import { useMemo } from 'react';
import moment from 'moment';
import { formatCurrency } from '../../../../../../../../../helpers/format';

const useTournamentData = data => {
  return useMemo(() => {
    const { buyin, fee, currency } = data.buyIn;
    const game = data.tournamentGames[0];
    const sitngo = data.tournamentType === 'sitngo';

    const buyIn = formatCurrency(buyin + fee, 'en', currency);
    const startsAt = sitngo ? 'SNG' : moment(data.startDate).format('MMM D HH:mm');
    const duration = moment.duration(moment(data.endDate).diff(data.startDate)).humanize();
    const endDate = moment(data.endDate).format('MMM D HH:mm');
    const thumbnail = !!game ? game.thumbnail  : '';

    return { startsAt, game, buyIn, currency, duration, thumbnail, endDate };
  }, [data]);
}

export default useTournamentData;